
import Broom from "../../../assets/duotone/Broom.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BroomIcon({ className, dataTestid = "BroomIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Broom data-testid={dataTestid} className={classes} {...rest} />
  );
}
